module.exports = __webpack_public_path__ + "static/img/smfk.32484f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/smfk.png
// module id = ZO7L
// module chunks = 1